module.exports = __webpack_public_path__ + "static/woyw-logo-c86d2fb6af7fb9b14d6f793356d021ac.png";